import PropTypes from 'prop-types';
import React from 'react';
import { Col, Container, Row } from '../../components/ui/Wrapper';
import Faq from '../Faq';
import { Wrapper } from './contact-form-area.style';

const ContactFormArea = ({ form }) => {
  return (
    <Wrapper>
      <Container>
        <Row>
          <Col lg={6}>{form}</Col>
          <Col lg={6} ml="auto">
            <Faq />
          </Col>
        </Row>
      </Container>
    </Wrapper>
  );
};

ContactFormArea.propTypes = {
  form: PropTypes.node.isRequired,
};

export default ContactFormArea;
